export default __webpack_public_path__ + "static/media/vehicle-icon.b552f369.svg";